import type { ApiEnvelope, ApiError } from "@noverik/contracts";

const API_BASE = import.meta.env.VITE_API_BASE ?? "/api/noverik/v1";

export class ApiRequestError extends Error {
  constructor(
    public readonly status: number,
    public readonly code: string,
    message: string,
  ) {
    super(message);
  }
}

type Options = Omit<RequestInit, "body"> & {
  body?: unknown;
  csrfToken?: string | null;
};

export async function apiRequest<T>(path: string, options: Options = {}): Promise<T> {
  const headers = new Headers(options.headers);
  headers.set("Accept", "application/json");

  if (options.body !== undefined) {
    headers.set("Content-Type", "application/json");
  }

  if (options.csrfToken) {
    headers.set("X-CSRFToken", options.csrfToken);
  }

  const response = await fetch(API_BASE + path, {
    ...options,
    credentials: "same-origin",
    headers,
    body: options.body === undefined ? undefined : JSON.stringify(options.body),
  });

  const payload = await response.json() as ApiEnvelope<T> | ApiError;

  if (!response.ok || "error" in payload) {
    const error = "error" in payload
      ? payload.error
      : { code: "http_error", message: "Falha ao acessar o serviço." };

    throw new ApiRequestError(response.status, error.code, error.message);
  }

  return payload.data;
}
